import { useReducer, useRef, useCallback, useEffect } from "react";
import { apiRequestReducer } from "./apiRequestReducer.js";
const initialState = {
  isLoading: false,
  isFinished: false,
  readyState: "uninitialized"
};
const useApiRequest = (client) => {
  const [state, dispatch] = useReducer(apiRequestReducer, initialState);
  const isUnmountedRef = useRef(false);
  const sendRequest = useCallback(
    async (query, variables = {}, options) => {
      if (isUnmountedRef.current) {
        return Promise.reject();
      }
      dispatch({
        type: "initialize"
      });
      return client.sendRequest(query, {
        ...options,
        variables
      }).then((data) => {
        dispatch({
          type: "resolveSuccessfully",
          data
        });
        return Promise.resolve(data);
      }).catch((error) => {
        dispatch({
          type: "resolveWithError",
          error
        });
        return Promise.reject(error);
      });
    },
    [client]
  );
  useEffect(
    () => () => {
      isUnmountedRef.current = true;
    },
    []
  );
  return [state, sendRequest];
};
export {
  useApiRequest
};
//# sourceMappingURL=useApiRequest.js.map
